import { instance } from '@app/api/axios';
import { useShowToaster } from '@shared/ui/messages/useToaster';

export function useWithdraw() {
  const showToaster = useShowToaster();

  const withdraw = async (data) => {
    try {
      const res = await instance.post('/balance/withdraw', data);
      showToaster('success', res?.data?.message);
      return true;
    } catch (err) {
      if (err?.response?.status != 422) {
        showToaster('error', err?.response?.data?.message);
        return false;
      }
      throw err;
    }
  };

  return { withdraw };
}
